import React, { useMemo, useState } from "react";
import { Button } from "react-bootstrap";

const categories = [
  "build and ship",
  "tech radar",
  "career and product thinking",
];

const ResourceFilters = ({
  resources,
  selectedCategory,
  setSelectedCategory,
  selectedTags,
  setSelectedTags,
  resetFilters,
}) => {
  const [visibleTagCount, setVisibleTagCount] = useState(6);

  const tagList = useMemo(() => {
    const tags = new Set();
    resources.forEach((r) => r.tags?.forEach((t) => tags.add(t.tag)));
    return [...tags];
  }, [resources]);

  const toggleCategory = (cat) => {
    setSelectedCategory(selectedCategory === cat ? "" : cat);
  };

  const toggleTag = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  return (
    <>
      {/* CATEGORY */}
      <div className="filter-title text-secondary">Category</div>
      <div className="mb-4 d-flex flex-wrap gap-2">
        {categories.map((cat) => (
          <Button
            key={cat}
            variant={selectedCategory === cat ? "primary" : "secondary"}
            className="filter-badge"
            onClick={() => toggleCategory(cat)}
          >
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </Button>
        ))}
      </div>

      {/* TAGS */}
      <p className="filter-title text-secondary">Tags</p>
      <div className="mb-3 d-flex flex-wrap gap-2">
        {tagList.slice(0, visibleTagCount).map((tag) => (
          <Button
            key={tag}
            variant={selectedTags.includes(tag) ? "primary" : "secondary"}
            className="filter-badge"
            onClick={() => toggleTag(tag)}
          >
            {tag}
          </Button>
        ))}
      </div>

      {visibleTagCount < tagList.length && (
        <Button
          variant="link"
          className="text-primary px-0"
          onClick={() => setVisibleTagCount((c) => c + 6)}
        >
          Show More ▼
        </Button>
      )}

      <div className="mt-4">
        <Button variant="primary" onClick={resetFilters}>
          Reset
        </Button>
      </div>
    </>
  );
};

export default ResourceFilters;
